import { Component, Input } from '@angular/core';


@Component({
  selector: 'ui-timeline',
  standalone: true,
  imports: [],
  templateUrl: './ui-timeline.component.html',
  styleUrl: './ui-timeline.component.scss'
})
export class UiTimelineComponent {
  /**
   * DaisyUI timeline orientation.
   * Keep as 'vertical' for the recipe detail view.
   */
  @Input() orientation: 'vertical' | 'horizontal' = 'vertical';

  /**
   * If true, forces vertical layout on small screens.
   */
  @Input() verticalOnMobile = true;

  get classes(): string {
    const classes: string[] = ['timeline'];

    // DaisyUI expects `timeline-vertical` or `timeline-horizontal`
    classes.push(this.orientation === 'horizontal' ? 'timeline-horizontal' : 'timeline-vertical');

    // Force a stable vertical layout on small screens (recipe wants left aligned on mobile)
    if (this.verticalOnMobile) {
      classes.push('max-md:timeline-vertical');
    }

    return classes.join(' ');
  }
}
